$(document).ready(function () {
  /******************************* Related Product Slider *******************************/
  $('#custom-related-product-section .product-wrapper').slick({
    slidesToShow: 2,
    slidesToScroll: 2,
    arrows: true,
    infinite: false,
    dots: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });



  /******************************* Accordion Drawer : Product Page *******************************/
  // Hide all accordion drawers initially
  $(".accordion__drawer").css("display", "none");

  // Close button functionality
  $(".drawer__close").click(function () {
    $(this).closest(".accordion__drawer").css("display", "none").removeClass("active");
    $(this).closest(".accordion__disclosure").removeAttr("open");
    $("body").removeClass("drawer-active");
  });

  // Toggle accordion drawers on button click
  $(".accordion__disclosure .accordion__toggle").click(function (e) {
    e.preventDefault(); // Prevent default behavior

    const accordion = $(this).closest(".accordion__disclosure");
    const drawer = accordion.find(".accordion__drawer");

    // Close other accordions
    $(".accordion__disclosure[open]").not(accordion).each(function () {
      $(this).removeAttr("open");
      $(this).find(".accordion__drawer").css("display", "none").removeClass("active");
    });

    // Toggle current accordion
    if (accordion.attr("open")) {
      accordion.removeAttr("open");
      drawer.css("display", "none").removeClass("active");
      $("body").removeClass("drawer-active");
    } else {
      accordion.attr("open", "true");
      drawer.css("display", "block").addClass("active");
      $("body").addClass("drawer-active");
    }
  });

  /******************************* End Accordion Drawer : Product Page *******************************/  

  /******************************* Product Image Slider *******************************/
  function initializeSlider() {
    // Destroy existing slider if already initialized
    if ($('#product-block-image-slider').hasClass('slick-initialized')) {
      $('#product-block-image-slider').slick('unslick');
    }

    // Initialize the slider
    $('#product-block-image-slider').slick({
      dots: false,
      arrows: false,
      infinite: true,
      speed: 700,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      fade: true,
      autoplaySpeed: 1000,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: false,
          },
        },
      ],
    });
  }

  // Initialize the slider on page load
  initializeSlider();

  // Reinitialize slider on Shopify variant or section updates
  $(document).on('shopify:section:load shopify:variant:change', function () {
    initializeSlider();
  });

  // Observe changes in the DOM for dynamic updates
  const observer = new MutationObserver(function (mutationsList) {
    mutationsList.forEach(function (mutation) {
      if (
        mutation.type === 'childList' &&
        $(mutation.target).find('#product-block-image-slider').length
      ) {
        initializeSlider();
      }
    });
  });

  // Observe the body for DOM changes (dynamic content updates)
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  /******************************* Collection Template Scroll Behavior *******************************/
  $(document).scroll(function () {
    const toolbar = $(".template-collection .collection-toolbar");

    if ($(window).scrollTop() > 0) {
      // Add white background when scrolling
      toolbar.css("background-color", "white").css("transition", "background-color 0.3s ease");
    } else {
      // Reset background color when at the top
      toolbar.css("background-color", "transparent");
    }
  });

});



 /******************************* Currency Product  *******************************/


document.addEventListener("DOMContentLoaded", function () {
    let spanElement = document.querySelector(".localization-toggle span");
    let salePriceElement = document.querySelector("sale-price");
    let regularPriceElement = document.querySelector("compare-at-price");
    
    if (spanElement && salePriceElement && regularPriceElement) {
        let textContent = spanElement.textContent.trim();
        
        // Extract only the currency sign
        let currencyMatch = textContent.match(/\((?:[A-Z]{3})\s*([\p{Sc}])\)/u);
        
        if (currencyMatch) {
            let currencySign = currencyMatch[1]; // Extracted currency sign
           
           function parsePrice(priceText) {
    // Remove any non-numeric characters except comma and dot
    let cleanedPrice = priceText.replace(/[^\d.,]/g, "");

    // Check if the price uses a comma as the decimal separator (European format)
            if (cleanedPrice.includes(",") && cleanedPrice.lastIndexOf(",") > cleanedPrice.lastIndexOf(".")) {
                    cleanedPrice = cleanedPrice.replace(",", ".");
            }
            
                return parseFloat(cleanedPrice);
            }
            
            let salePrice = parsePrice(salePriceElement.textContent);
            console.log("Sale Price:", salePrice);
            
            let regularPrice = parsePrice(regularPriceElement.textContent);
            console.log("Regular Price:", regularPrice);

            if (!isNaN(salePrice) && !isNaN(regularPrice)) {
                let discountAmount = regularPrice - salePrice;
                console.log("Discount Amount:", discountAmount);

                // Create a new style element
                let style = document.createElement("style");
                style.innerHTML = `
                    /* Desktop Version */
                    .page-ishu-mirror-phonecase fieldset.variant-picker__option.v-stack.gap-2:nth-of-type(2) 
                    .relative label.popover__value-option.h-stack.justify-between.gap-2:nth-of-type(1)::after {
                        content: "-${discountAmount.toFixed(0)} ${currencySign}";
                        display: inline-block;
                        width: 45px;
                        height: 20px;
                        margin-left: 8px;
                        font-size: 9px;
                        border: 2px solid #000;
                        border-radius: 5px;
                        padding: 2px 3px;
                        font-weight: 700;
                        color: #000;
                    }

                    /* Mobile Version */
                    @media (max-width: 1249px) {
                        #popover-variant-dropdown-template--21823994429463__main-7362795077655-2 
                        label.popover__value-option.h-stack.justify-between.gap-2:nth-of-type(1)::after {
                            content: "-${discountAmount.toFixed(0)} ${currencySign}";
                            display: inline-block;
                            width: 45px;
                            height: 20px;
                            margin-left: 8px;
                            font-size: 9px;
                            border: 2px solid #000;
                            border-radius: 5px;
                            padding: 2px 3px 2px 8px;
                            font-weight: 700;
                            color: #000 !important;
                        }
                    }
                `;
                document.head.appendChild(style); // Append the style to the document
            }
        }
    }
});



















